import React, {useState, useEffect, useRef} from "react";
import {connect} from "react-redux";
import {withRouter} from "../../../helpers/withRouter";
import T from "../../../shared/component/t/T";
import snippets from "../../../helpers/snippets";
import {PatientSex2} from "../../../core/constants/PatientSex";
import {default as _} from '../../../helpers/Translate';
import {Link} from "react-router-dom";

function ReportCP_PatientInfo(props) {
    const detailsRef = useRef()
    const [language] = useState(props.language)
    const [data] = useState(props.data)
    const [showInfo, setShowInfo] = useState(false)

    useEffect(()=>{
        if (showInfo){
            window.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            window.removeEventListener('mousedown', handleClickOutside);
        };
    },[showInfo])

    const collapseClick = (e) => {
        if (!e.target.className.includes("__patientFile")) {
            setShowInfo((prevShowInfo) => !prevShowInfo)
        }
    }

    const handleClickOutside = (event) => {
        if (detailsRef?.current && !detailsRef?.current?.contains(event.target)) {
            setShowInfo(false)
        }
    }

    return (
        <>
            <div className='info' ref={detailsRef}>
                <div className='info__title' onClick={collapseClick}>
                    {showInfo ? <>
                            <div className='__header'>
                                <T token={"patient_info"} />
                            </div>
                        </>
                        :
                        <>
                            <div className='Item'>
                                <span className='__title'><T token={"full_name"} />: </span>
                                <div className='__info'>{data?.full_name}</div>
                            </div>
                            |
                            <div className='Item'>
                                <span className='__title'><T token={"patient_id"} />: </span>
                                <div className='__info'><strong>{_.init3(data?.patient_code)}</strong></div>
                            </div>
                        </>
                    }
                </div>

                <div className='patientDropdown'>
                    {data?.link_to_docs_on_his &&
                        <div className='__patientFile' >
                            <Link target="_blank" to={data?.link_to_docs_on_his}
                                  rel="noreferrer"
                                  replace={true}
                                  className={'print_report_link'}
                            >
                                <span className={"icon"}><i className={"fal fa-file-text fa-xl"} /></span>
                                <span className={"buttonText"}><T token={"patient_file"} /></span>
                            </Link>
                        </div>
                    }
                    <div className='Dropdownicon' onClick={collapseClick}>
                        {!showInfo ?
                            <i className={'fa fa-angle-down'} />
                            :
                            <i className={'fa fa-angle-up'} />
                        }
                    </div>
                </div>

                {showInfo && <>
                    <div className='details' >
                        <div className='Item'>
                            <span className='__title'><T token={"full_name"} />:</span>
                            <div className='__info'>{data?.full_name}</div>
                        </div>
                        <div className='Item'>
                            <span className='__title'><T token={"his_name"} />:</span>
                            <div className='__info'>{data?.his_full_name}</div>
                        </div>
                        <div className='Item'>
                            <span className='__title'><T token={"patient_id"} />:</span>
                            <div className='__info'><strong><T token={data?.patient_code} /></strong></div>
                        </div>
                        <div className='Item'>
                            <span className='__title'><T token={"visit_time"} />:</span>
                            <div className='__info'>
                                <T token={snippets.datetime(data?.date)} />
                            </div>
                        </div>
                        <div className='Item'>
                            <div className='__title'><T token={"gender"} />:</div>
                            <div className='__info'><T token={PatientSex2(data?.sex)} /></div>
                        </div>
                        <div className='Item'>
                            <div className='__title'><T token={'birth_date'} />{" ("}<T token={'age'} />{")"}:</div>
                            <div className='__info'>{_.init3(snippets.datetime(data?.birth_date), language)}{` (${_.init3(data?.age_title, language)})`}</div>
                        </div>

                        {data?.reason && <div className='Item'>
                            <div className='__title'><T token={'study_reason'} />:</div>
                            <div className='__info'
                                 title={data?.reason}
                            >{data?.reason}</div>
                        </div>}

                        {data?.his_comments && <div className='Item'>
                            <div className='__title'><T token={'his_comments'} />:</div>
                            <div className='__info'
                                 title={data?.his_comments}
                            >{data?.his_comments}</div>
                        </div>}
                        {data?.surgical_history && <div className='Item'>
                            <div className='__title'><T token={'surgical_history'} />:</div>
                            <div className='__info'
                                 title={data?.surgical_history}
                            >{data?.surgical_history}</div>
                        </div>}
                        {data?.external_object_in_body && <div className='Item'>
                            <div className='__title'><T token={'external_object_in_body'} />:</div>
                            <div className='__info'
                                 title={data?.external_object_in_body}
                            >{data?.external_object_in_body}</div>
                        </div>}
                    </div>
                </>
                }
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(ReportCP_PatientInfo));